import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";

/**
 * UI state of the purchased-tickets viewer.
 *
 * @remarks Deliberately independent from {@link ticketPurchaseSlice}: viewing
 * issued tickets is a separate feature from the purchase wizard — the two
 * modals only share the `SheetModal` shell.
 */
export interface TicketViewerState {
    "isOpen": boolean;

    /** `entry.itinerary.id` of the purchased itinerary to display. */
    "itineraryId": string | null;

    /** `offer.segments` key to focus first — `null` opens on the first ticket. */
    "initialSegmentId": string | null;
}

/** Closed viewer state (also the reset value on close). */
export const TICKET_VIEWER_DEFAULT: TicketViewerState = {
    "isOpen":           false,
    "itineraryId":      null,
    "initialSegmentId": null,
};

/** Ephemeral slice: purchased-tickets viewer state. */
export const ticketViewerSlice = defineEphemeralSlice<TicketViewerState>( {
    "key":     "ticketViewer",
    "default": () => TICKET_VIEWER_DEFAULT,
} );
